import * as React from "react";

export const BookIcon = (): React.ReactElement => (
    <svg width="22" height="19" viewBox="0 0 22 19" fill="none">
        <path
            d="M10.75 4a3 3 0 0 1 3-3h6a.75.75 0 0 1 .75.75v12a.75.75 0 0 1-.75.75h-6a3 3 0 0 0-3 3M1 13.75a.75.75 0 0 0 .75.75h6a3 3 0 0 1 3 3V4a3 3 0 0 0-3-3h-6a.75.75 0 0 0-.75.75v12z"
            stroke="#1865F2"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const MathIcon = (): React.ReactElement => (
    <svg width="46" height="46" viewBox="0 0 46 46" fill="none">
        <path
            d="M23 46c12.70 0 23-10.30 23-23S35.70 0 23 0 0 10.30 0 23s10.30 23 23 23z"
            fill="#FCB500"
        />
        <path
            d="M10.74 16.42a5.69 5.69 0 0 1 11.38 0v5.48H10.74v-5.48z"
            fill="#F46A37"
        />
        <path
            d="M10.74 16.42a5.69 5.69 0 0 1 11.38 0v5.48H10.74v-5.48z"
            stroke="#F4EEE2"
        />
        <path
            d="M23.77 29.21a5.69 5.69 0 0 1 11.38 0v5.48H23.77v-5.48z"
            fill="#5F1E5C"
        />
        <path
            d="M23.77 29.21a5.69 5.69 0 0 1 11.38 0v5.48H23.77v-5.48z"
            stroke="#F4EEE2"
        />
        <path
            d="M10.74 29.21a5.69 5.69 0 0 1 11.38 0v5.48H10.74v-5.48z"
            fill="#0B2149"
        />
        <path
            d="M10.74 29.21a5.69 5.69 0 0 1 11.38 0v5.48H10.74v-5.48z"
            stroke="#F46A37"
        />
        <path
            d="M23.77 16.42a5.69 5.69 0 1 1 11.38 0v5.48H23.77v-5.48z"
            fill="#F4EEE2"
        />
        <path
            d="M23.77 16.42a5.69 5.69 0 1 1 11.38 0v5.48H23.77v-5.48z"
            stroke="#F46A37"
        />
        <path d="M26.61 17.13v-1.6h5.29v1.6h-5.29z" fill="#F46A37" />
        <path
            d="M15.57 19.13v-2.29h-1.99v-1.41h1.99v-2.29h1.32v2.29h1.99v1.41H16.89v2.29h-1.32z"
            fill="#0B2149"
        />
        <path
            d="M29.26 27.80a0.99.99 0 0 1-0.70-0.26.91.91 0 0 1-0.28-0.68c0-0.28.10-0.50.28-0.67a0.99.99 0 0 1 0.70-0.26c.28 0 0.52.09.70.26.19.17.28.39.28.67a0.91.91 0 0 1-0.28.68.00.00 0 0 1-0.70.26zm0 4.13a0.99.99 0 0 1-0.70-0.26.91.91 0 0 1-0.28-0.68c0-0.28.10-0.50.28-0.67a1.00.00 0 0 1 0.70-0.26c.28 0 0.52.09.70.26.19.17.28.39.28.67a0.91.91 0 0 1-0.28.68.00.00 0 0 1-0.70.26zm-2.65-2.36v-1.28h5.29v1.28h-5.29z"
            fill="#EEAD7A"
        />
        <path
            d="M13.18 31.92l1.94-2.91-1.81-2.69h1.95l0.53.84c0.08.16.18.32.27.48.11.17.21.33.30.48h0.05c0.07-0.16.14-0.32.22-0.48.08-0.17.16-0.33.22-0.48l0.45-0.84h1.90l-1.83 2.89 1.94 2.71h-1.95l-0.59-0.85a13.18 13.18 0 0 0-.32-0.48c-0.11-0.17-0.21-0.33-0.31-0.48h-0.04c-0.08.16-0.17.32-0.25.48a9.61 9.61 0 0 0-.24.48l-0.50.85h-1.90z"
            fill="#F4EEE2"
        />
    </svg>
);

const scienceStyle =
    ".cls-1{fill:#ffbe26;}.cls-2,.cls-3{fill:#01d1c1;}.cls-2{opacity:0.25;}";
export const ScienceIcon = (): React.ReactElement => (
    <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        width="46"
        height="46"
        viewBox="0 0 256 256"
    >
        <defs>
            <style>{scienceStyle}</style>
        </defs>
        <rect
            className="cls-1"
            x="83.09"
            y="186.79"
            width="89.82"
            height="40.34"
        />
        <path
            className="cls-1"
            d="M128,202.18v-17a37.91,37.91,0,0,0,0-75.81v-17a54.88,54.88,0,0,1,0,109.75Z"
        />
        <rect
            className="cls-2"
            x="83.09"
            y="186.79"
            width="89.82"
            height="6.91"
        />
        <rect
            className="cls-3"
            x="55.46"
            y="213.31"
            width="145.09"
            height="23.69"
        />
        <rect
            className="cls-3"
            x="65.33"
            y="173.96"
            width="125.35"
            height="12.83"
        />
        <path
            className="cls-3"
            d="M107.77,19h40.47a0,0,0,0,1,0,0v6.17a12.58,12.58,0,0,1-12.58,12.58H120.35a12.58,12.58,0,0,1-12.58-12.58V19a0,0,0,0,1,0,0Z"
        />
        <rect
            className="cls-3"
            x="114.68"
            y="33.8"
            width="26.65"
            height="113.5"
        />
        <rect
            className="cls-1"
            x="107.77"
            y="43.67"
            width="40.47"
            height="93.76"
        />
        <circle className="cls-3" cx="148.23" cy="105.85" r="13.82" />
    </svg>
);
